import { render } from "./LanguageSwitcher.vue?vue&type=template&id=db7c4400&scoped=true"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js"

import "./LanguageSwitcher.vue?vue&type=style&index=0&id=db7c4400&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db7c4400"],['__file',"src/vue/components/LanguageSwitcher.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "db7c4400"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('db7c4400', __exports__)) {
    api.reload('db7c4400', __exports__)
  }
  
  module.hot.accept("./LanguageSwitcher.vue?vue&type=template&id=db7c4400&scoped=true", () => {
    api.rerender('db7c4400', render)
  })

}


export default __exports__